// extracted by mini-css-extract-plugin
module.exports = {"upDownButton":"up_down_button_style_upDownButton__19UMF","upButton":"up_down_button_style_upButton__1238V","downButton":"up_down_button_style_downButton__1k07v"};